module.exports = __webpack_public_path__ + "img/tddg-2.1a56eb68.webp";